import { Col, Container, Row } from 'react-bootstrap'
import { selectFooter } from 'store/settingsSlice'
import { useSelector } from 'react-redux'
import ScrollToTopButton from './ScrollToTopButton'
import { stripInvisibleChars } from 'utils/functions'

export const Footer = () => {
  const footer = useSelector(selectFooter)
  if (!footer) return <></>

  return (
    <footer className="mt-auto bg-light py-5">
      <ScrollToTopButton />
      <Container>
        <Row className="gy-4">
          <Col lg={3}>
            {footer.footerLogoUrl && <img width="200" src={footer.footerLogoUrl} alt="Startsida, Region Stockholm" />}
          </Col>
          <Col lg={3} className="footer-column">
            <h2 className="footer-column__heading fw-bold">{footer.footerFirstColumnTitle}</h2>
            {footer.footerFirstColumnText && (
              <div dangerouslySetInnerHTML={{ __html: stripInvisibleChars(footer.footerFirstColumnText) }}></div>
            )}
          </Col>
          <Col lg={3} className="footer-column">
            <h2 className="footer-column__heading fw-bold">{footer.footerSecondColumnTitle}</h2>
            {footer.footerSecondColumnText && (
              <div dangerouslySetInnerHTML={{ __html: stripInvisibleChars(footer.footerSecondColumnText) }}></div>
            )}
          </Col>
          <Col lg={3} className="footer-column">
            <h2 className="footer-column__heading fw-bold">{footer.footerThirdColumnTitle}</h2>
            {footer.footerThirdColumnText && (
              <div dangerouslySetInnerHTML={{ __html: stripInvisibleChars(footer.footerThirdColumnText) }}></div>
            )}
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
